module.exports = (fox) => {
	const UID_LABEL = 'exo_uid';

	fox.registerService('exodentity', {
		_included: false,
		_fingerprint: null,

		include() {
			if (this._included)
				return fox.Promise.resolve(false);

			return new fox.Promise((resolve) => {
				require.ensure([], () => {
					this.addExodentityScript()

					return resolve(require('script!exodentity/exodentity.min'));
				})
			});
		},

		getSavedUid() {
			return [
				() => localStorage.getItem(UID_LABEL),
				() => {
					const uid = fox.cookie.get(UID_LABEL);

					if (uid)
						return decodeURIComponent(unescape(uid));

					return false;
				}
			].reduce((fingerprint, next) => {
				if (fingerprint)
					return fingerprint;

				return next();
			}, this._fingerprint);
		},

		addExodentityScript(loadAsync = false) {
			window.__exoCallback = (response) => {
				this._fingerprint = response;

				fox.site.dispatchEvent('exodentity_fingerprint_recieved', {
					fingerprint: response
				});

				fox.cookie.set(UID_LABEL, window.escape(response));

				try {
					localStorage.setItem(UID_LABEL, response);
				} catch (e) { /* do nothing... */ }
			};

			window._axq = {
				'js_callback': '__exoCallback'
			};

			this._included = true;
		}
	});
};



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/services/exodentity.es.js